// Only a completed package comparison can prove that no iFlow parameters exist.
// Released-iFlow lists are unsuitable here: they omit drafts, which still belong
// to the package. A missing or failed inventory must keep the normal read path.
export function parameterRequirement(state, selectedBuckets) {
  if (state.precheckState !== "done" || !state.pkgId || !state.sourceInstanceId
      || !state.space?.qasInstance?.id || !selectedBuckets?.length) return "required";
  if (Object.values(state.sel || {}).some(choices => Object.values(choices || {}).some(Boolean))) return "required";
  const entries = Object.values(state.precheckByBucket || {});
  if (!entries.length || entries.some(entry => !entry || entry.error
      || entry.transportMode !== "package" || !Array.isArray(entry.comparison) || entry.comparison.length !== 0
      || !Array.isArray(entry.designArtifacts) || entry.designArtifacts.length === 0
      || entry.packageExportUnavailable || entry.packageExportUnclear || entry.plantRenameFailed)) return "required";
  const targetId = state.space.qasInstance.id;
  const covered = selectedBuckets.every(bucket => entries.some(entry =>
    entry.instance?.id === targetId && (entry.werk?.kennung || "") === (bucket.kennung || "")
      && (!bucket.kennung || /^[a-f0-9]{64}$/i.test(entry.plantTargetRevision || ""))));
  return covered ? "not-required" : "required";
}
